// @flow

import { UPDATE_CART_GROUPS, UPDATE_CART_GROUPS_PRICE } from './constants';
import { getConfigBuilder } from '../configBuilder/selectors';
import { getActiveByConfigBuilderType } from '../actives/selectors';
import type {
  CartGroups,
  CartPrice,
} from './types';
import { getActivePdbId } from '../../pdb/selectors';

export const setCartGroups = (groups: CartGroups, pdbId: string) => ({
  type: UPDATE_CART_GROUPS,
  groups,
  pdbId,
});

export const setCartGroupsPrice = (price: CartPrice, pdbId: string) => ({
  type: UPDATE_CART_GROUPS_PRICE,
  price,
  pdbId,
});

export const updateCart = (pdbId?: ?string) => (dispatch: Function, getState: Function) => {
  const state = getState();
  const selectedPdbId = pdbId || getActivePdbId(state);
  const configBuilder = getConfigBuilder(state) || [];
  const groups = configBuilder.map(group => {
    const groupItems = group.elements.reduce((items, element) => {
      // Find active for each item
      const itemType = element.acf_fc_layout;
      const active = getActiveByConfigBuilderType(state, itemType, pdbId);

      if (Array.isArray(active)) {
        // Deal with array actives
        if (!active.length) {
          return items;
        }

        return items.concat(active.map(activeItem => ({
          active: activeItem,
          price: Number(activeItem.price),
          type: itemType,
        })));
      }

      if (!active) {
        // No active: ignore items
        return items;
      }

      return items.concat([{
        active,
        price: Number(active.price),
        type: itemType,
      }]);
    }, []);

    // Return mapped group with items and price
    return {
      items: groupItems,
      price: groupItems.reduce((price, item) => price + item.price, 0),
      title: group.header,
      id: group.id,
    };
  });

  if (selectedPdbId) {
    dispatch(setCartGroups(groups, selectedPdbId));
    dispatch(setCartGroupsPrice(
      groups.reduce((price, group) => price + group.price, 0),
      selectedPdbId,
    ));
  }
};

export default null;
